module.exports = __webpack_public_path__ + "img/list.f0d629d0.svg";